import { Outlet } from 'react-router-dom';
import React from 'react';
import SEO, { SITE_NAME } from '../Components/SEO';

const MainFrame = () => {
  

  return (
    <div>
      <SEO
        title="Free English Lesson Plans and Practice Exercises"
        description="Free English practice materials, exercises and lesson plans for teachers and students. Practise grammar, reading, writing, speaking, vocabulary and exam-style English online for free."
        name={SITE_NAME}
        type="article"
      />
      
      <>
      
        <div className="grid">
          <main className="main">
            <Outlet />
          </main>
        </div>
      </>
    </div>
  );
};

export default MainFrame;
